import store from '@/store'
import actions from '@/store/actions'

import { authContext } from '../plugins/msalPlugin'

const TYPES_LABELS = {
  claim: 'Claim',
  variation: 'Variation',
  amendment: 'Amendment',
  early_warning: 'Early Warning'
}

export const createMilestoneForVariation = async (data) => {
  delete data.lastUpdateDate
  delete data.part
  delete data.risk
  const variation = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${data.contractId}/variations/${data.id}/milestone`,
      method: 'POST',
      body: {
        ...data,
        user: authContext.account.name
      }
    }
  )
  store.dispatch(actions.createMessage, { text: `Milestone for ${TYPES_LABELS[data.type]} created`, color: 'success' })
  return variation
}

export const updateVariation = async (data) => {
  delete data.lastUpdateDate
  delete data.part
  delete data.risk
  delete data.currency
  const variation = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${data.contractId}/variations/${data.id}`,
      method: 'PUT',
      body: {
        ...data,
        user: authContext.account.name
      }
    }
  )
  store.dispatch(actions.createMessage, { text: `${TYPES_LABELS[data.type]} updated`, color: 'success' })
  return variation
}

export const commentVariation = async (contractId, variationId, comment) => {
  return store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/variations/${variationId}/comment`,
      method: 'PUT',
      body: comment
    }
  )
}

export const updateVariationHistoryComment = async (contractId, variationId, historyId, userComment) => {
  return store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/variations/${variationId}/history/${historyId}/comment`,
      method: 'PUT',
      body: {
        userComment
      }
    }
  )
}

export const addDocumentToVariation = async (data, contractId, variationId) => {
  await store.dispatch(actions.callApi, {
    url: `contracts/${contractId}/variations/${variationId}/documents`,
    method: 'post',
    body: data
  })
  store.dispatch(actions.createMessage, { text: 'Document added', color: 'success' })
}

export const upgradeVariation = async (data) => {
  return store.dispatch(
    actions.callApi,
    {
      url: `contracts/${data.contractId}/variations/${data.id}/upgrade/${++data.stage}`,
      method: 'PUT',
      body: {
        user: authContext.account.name
      }
    }
  )
}

export const getVariationsForContract = async (contractId, type) =>
  store.dispatch(actions.callApi, {
    url: `contracts/${contractId}/variations`,
    params: { type }
  })

export const createVariationForContract = async (contractId, data) => {
  const variation = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/variations`,
      method: 'POST',
      body: {
        ...data,
        user: authContext.account.name
      }
    }
  )
  store.dispatch(actions.createMessage, { text: `${TYPES_LABELS[data.type]} created`, color: 'success' })
  return variation
}
export const importVariationsForContract = async (type, contractId, data) => {
  const variation = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/variations/import`,
      method: 'POST',
      body: data.map(i => ({
        no: i.no,
        noList: i.noList,
        receivedDate: i.receivedDate,
        reportingSide: i.reportingSide,
        workstream: i.workstream,
        category: i.category,
        name: i.name,
        description: i.description,
        revisionHistory: [],
        type,
        status: i.status,
        stage: i.stage,
        riskId: i.risk.id,
        parts: i.parts,
        user: authContext.account.name,
        referenceNumber: i.referenceNumber
      }))
    }
  )
  store.dispatch(actions.createMessage, { text: `${TYPES_LABELS[data[0].type]}s created`, color: 'success' })
  return variation
}

export const deleteVariationComment = async (contractId, variationId) => {
  return store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/variations/${variationId}/comment/last`,
      method: 'DELETE'
    }
  )
}

export const deleteVariation = async (data) => {
  const variation = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${data.contractId}/variations/${data.id}`,
      method: 'DELETE'
    }
  )
  store.dispatch(actions.createMessage, { text: `${TYPES_LABELS[data.type]} deleted`, color: 'success' })
  return variation
}
